<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="Course1">
        <!-- 微导航 -->
        <div class="wnav">
          <span>课程体系</span> >
          <span>精选课程</span> >
          <span class="gengduo">更多</span>
        </div>
        <!-- 导航 -->
        <div class="nav">
          <ul>
            <li
              v-for="(tab,index) in tabs"
              :key="index"
              @click="toggle(index,tab.id,1)"
              :class="{active:active==index}"
            >{{tab.name}}</li>
          </ul>
        </div>
      </div>
      <div>
        <div class="Course">
          <div class="details">
            <div
              class="list"
              @click="godetails(list.id)"
              v-for="(list,index) in lists"
              :key="index"
            >
              <img :src="list.image" alt />
              <p class="title">{{list.name}}</p>
              <div class="jiage">
                <img class="touxiang" :src="list.teacher_image" alt />
                <p class="name">{{list.teacher_name}}</p>
                 <p class="price" v-if="list.members_free==1">VIP免费</p>
                  <p class="price" v-if="list.price!=0.00&&list.members_free==0">¥{{list.price}}</p>
                  <p class="price" v-if="list.price==0.00">免费</p>
              </div>
              <div class="solid"></div>
              <div class="list-footer">
                <div class="left">
                  <img src="../assets/img/se.png" alt />
                  <span>{{list.sales}}</span>
                </div>
                <div class="center"></div>
                <div class="right">
                  <img src="../assets/img/pl.png" alt />
                  <span>{{list.number}}</span>
                </div>
              </div>
            </div>
          </div>
          <div style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout=" prev, pager, next"
              :total="totalNum"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <login v-show="popup==1"></login>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./header";
import Footer from "./footer";
import Login from "./popup/login";
export default {
  name: "course-more",
  data() {
    return {
      active: 0,
      currentView: "",
      tabs: [],
      lists: [],
      popup: "",
      currentPage: 1, //默认显示第一页
      pageSize: 8, //默认每页显示条
      totalNum: 0 //总页数
    };
  },
  methods: {
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val; //动态改变
      this.toggle(this.active,this.currentView);
    },
    // 课程分类
    async course_type_list() {
      await this.$service.home
        .course_type_list({})
        .then(res => {
          // console.log(res.data);
          if (res.data.code == 200) {
            this.tabs = res.data.content;
            // 默认
            this.currentView = res.data.content[0].id;
            this.toggle();
            this.handleCurrentChange();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 更多课程列表
    async toggle(i, v,p) {
      if (p) {
        this.currentPage = p;
      }
      if (i == undefined) {
        this.active = 0;
      } else {
        this.active = i;
        this.currentView = v;
      }
      var type_id = this.currentView;
      await this.$service.home
        .course_list({
          type_id: type_id,
          page: this.currentPage,
          page_count: this.pageSize
        })
        .then(res => {
          // console.log(res.data.content.list);
          if (res.data.code == 200) {
            this.lists = res.data.content.list;
            // 向上取整数
            var totalNum = Math.ceil(res.data.content.count);
            this.totalNum = totalNum;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 跳转课程详情
    godetails(id) {
        this.$router.push({
          path: "/details",
          query: {
            id: id
          }
        });
    }
  },
  components: {
    Header,
    Footer,
    Login
  },
  mounted() {
    this.course_type_list();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 导航 */

.wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
.Course1,
.Course {
  margin: 0 auto;
  width: 1200px;
  position: relative;
}
.Course1 .nav {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 21px;
}
.Course1 ul {
  width: 100%;
  display: inline-flex;
  justify-content: space-around;
}
.Course1 ul li {
  font-size: 16px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
}
.Course1 ul li.active {
  color: #1775ef;
}
.Course {
  width: 1200px;
  margin: 0 auto;
}
.Course .details {
  width: 1250px;
  margin: 0 auto;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}
.Course .list {
  margin-bottom: 48px;
  width: 270px;
  height: 350px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  border: 1px solid rgba(234, 234, 234, 1);
  margin-right: 39px;
}
.Course .list img {
  width: 270px;
  height: 180px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.Course .list .title {
  text-align: left;
  width: 245px;
  height: 50px;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  letter-spacing: 1px;
  margin: 10px 0 10px 13px;
    display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /*控制可显示几行文本*/
}
.Course .list .jiage {
  display: flex;
  text-align: center;
  margin: 0 8px 20px 13px;
  height: 30px;
}
.Course .list .jiage .touxiang {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.Course .list .jiage p.name {
  min-width: 61px;
  height: 20px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 4px;
  margin-right: 60px;
}
.Course .list .jiage p.price {
  /* width: 59px; */
  height: 16px;
  font-size: 18px;
  color: rgba(255, 67, 67, 1);
  line-height: 1px;
}
.Course .list .solid {
  width: 270px;
  height: 1px;
  background: rgba(234, 234, 234, 1);
}
.Course .list .list-footer {
  display: flex;
  justify-content: space-around;
}
.Course .list .list-footer .left,
.Course .list .list-footer .right {
  width: 50px;
  display: flex;
  justify-content: space-around;
  line-height: 35px;
}
.Course .list .list-footer .left img,
.Course .list .list-footer .right img {
  width: 17px;
  height: 12px;
  margin-top: 12px;
}
.Course .list .list-footer .center {
  width: 1px;
  height: 20px;
  background: rgba(234, 234, 234, 1);
  margin-top: 7px;
}
.Course .list .list-footer .right span,
.Course .list .list-footer .left span {
  width: 21px;
  height: 16px;
  font-size: 12px;
  color: rgba(136, 136, 136, 1);
}
/*分页*/
.page-bar {
  margin: 0 auto;
  width: 1200px;
}
.page-bar ul {
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  padding-bottom: 56px;
}
.page-bar li:first-child > a {
  margin-left: 0px;
}
.page-bar a {
  border: 1px solid #ddd;
  text-decoration: none;
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: rgba(51, 51, 51, 1);
  margin-right: 20px;
}
.page-bar a:hover {
  background-color: #eee;
}
.page-bar a.banclick {
  cursor: not-allowed;
}
.page-bar .active a {
  color: #fff;
  cursor: default;
  background-color: #1775ef;
  border-color: #1775ef;
}
.page-bar i {
  font-style: normal;
  color: #1775ef;
  margin: 0px 4px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/course_more.vue